const SupportedCourier = () =>
  import(
    /* webpackChunkName: "supported" */ '@/pages/supported/range-type/courier'
  )
const SupportedDriver = () =>
  import(
    /* webpackChunkName: "supported" */ '@/pages/supported/range-type/driver/'
  )

export default {
  path: 'range-type',
  meta: {
    label: 'SupportedRangeType',
    auth: 'rangeType'
  },
  component: {
    name: 'SupportedRangeType',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SupportedRangeTypeCourier',
      path: 'courier',
      meta: {
        auth: 'courier'
      },
      component: SupportedCourier
    },
    {
      name: 'SupportedRangeTypeDriver',
      path: 'driver',
      meta: {
        auth: 'driver'
      },
      component: SupportedDriver
    }
  ]
}
